import React, { Component } from 'react';
import InfoBox from './InfoBox.js';
import Cutlery from '../../../svg/Cutlery.js';
import Formsy from 'formsy-react';
import FormsySelectMui from '../../form/FormsySelectMui';

const portionOptions = [
  { label: 'Small (1-2 Mouths)', value: 'small' },
  { label: 'Medium (3-4 Mouths)', value: 'medium' },
  { label: 'Large (5-6 Mouths)', value: 'large' }
];

class Portion extends Component {
  state = {
    client: {
      portion_size: ''
    },
    isCurrentStep: false
  };
  render() {
    const { setStepAsValid, setStepAsInvalid } = this.props;
    const { portion_size } = this.state.client;
    const { isCurrentStep } = this.state;

    return (
      <React.Fragment>
        <InfoBox
          headline="How many mouths are you feeding?"
          subline="Our portions are based on household size, but you should adjust your
          selection based on household appetities. Portion size only effects
          grocery costs and can be changed week to week."
          icon={<Cutlery />}
        />
        <Formsy
          onValid={() => setStepAsValid(isCurrentStep)}
          onInvalid={() => setStepAsInvalid(isCurrentStep)}
          className="onboarding-new__form"
        >
          <div className="row">
            <div className="row__item row__item--full">
              <FormsySelectMui
                name="portion_size"
                placeholder="Portion Size"
                value={portion_size}
                options={portionOptions}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                required
              />
            </div>
          </div>
        </Formsy>
      </React.Fragment>
    );
  }

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ client: { ...this.state.client, [name]: value } });
  };

  handleClientUpdate = () => {
    const { client } = this.state;
    this.props.updateClient(client);
  };

  componentDidMount() {
    const { client } = this.props;
    this.setState({ client });
  }

  componentDidUpdate(prevProps) {
    const { hasSubmitted, isCurrentStep = false, client } = this.props;

    if (prevProps.client !== client) this.setState({ client });

    if (prevProps.isCurrentStep !== isCurrentStep)
      this.setState({ isCurrentStep });

    if (
      isCurrentStep &&
      hasSubmitted !== prevProps.hasSubmitted &&
      hasSubmitted === true
    ) {
      // Watch for next button click then update client in parent component
      this.handleClientUpdate();
    }
  }
}

export default Portion;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/Portion.js